import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private _history: string[] = [];

  constructor(private _router: Router, private _location: Location) {
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this._history.push(event.urlAfterRedirects);
      }
    });
  }

  back(): void {
    const lastPage = this._history.pop();
    if (lastPage != null) {
      this._location.back();
    } else {
      void this._router.navigate(['']);
    }
  }

  clear() {
    this._history = [];
  }
}
